import React, { useState } from 'react';
import { AiPlatformSection } from '../components/AiPlatformSection';
import { DataFoundationSection } from '../components/DataFoundationSection';
import { DemandCalloutSection } from '../components/DemandCalloutSection';
import EventList from '../components/EventList';
import { GetStartedDialog } from '../components/GetStartedDialog';
import { HeroSection } from '../components/HeroSection';
import { CommerceLoopSection } from '../components/CommerceLoopSection';
import { SEO } from '../components/SEO';
import { TestimonialSection } from '../components/TestimonialSection';
import MainLayout from '../layouts/main';

export default () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <MainLayout>
      <SEO title="Affilimate: AI Commerce Infrastructure for Content Publishers" />
      <HeroSection
        onGetStarted={() => setDialogOpen(true)}
        showLogos
      />
      <GetStartedDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
      <TestimonialSection />
      <CommerceLoopSection />
      <DataFoundationSection />
      <AiPlatformSection />
      <DemandCalloutSection />
      <EventList />
    </MainLayout>
  );
};
